module.exports = __webpack_public_path__ + "static/media/53095660_2452987048109805_4819125517120700416_o.a5c689ea.jpg";